'use strict';
import {DeviceServicesCordova} from './DeviceServicesCordova';

const angular = require('angular');


module.exports = angular
  .module('app.core-utilities-implementation.device-services', [])
  .factory('DeviceServicesImpl', DeviceServicesCordova)
;



// WEBPACK FOOTER //
// ./src/js/core-utilities-implementation/device-services/index.js